import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { take } from 'rxjs/operators';
import { ApiError, ButtonLoader, MessageService } from '../../../../../core';
import { ClienteAnaliseMercadoRevisaoAprovarRequest, ClienteAnaliseMercadoRevisaoSearch } from '../../adapters';
import { ClienteAnaliseMercadoRevisaoHttpService } from '../../services';

@Component({
    selector: 'sgt-cliente-analise-mercado-revisao-aprovar-modal',
    templateUrl: './cliente-analise-mercado-revisao-aprovar-modal.component.html',
    styleUrls: ['./cliente-analise-mercado-revisao-aprovar-modal.component.less']
})
export class ClienteAnaliseMercadoRevisaoAprovarModalComponent implements OnInit {
    // Config
    /** Título da modal */
    @Input() title = 'Aprovar Revisão das Análises de Mercado';
    /** Subtítulo do modal */
    @Input() subtitle: string = null;
    /** Form da modal */
    @ViewChild('form') form: NgForm;

    /** Evento após aprovar a revisão das Análises de Mercado */
    @Output() afterAprovar = new EventEmitter<ClienteAnaliseMercadoRevisaoSearch>();

    // Modal
    @ViewChild('modal', {static: true}) modal: ElementRef;
    @ViewChild('textAreaJustificativa') textAreaJustificativa: ElementRef;
    elModal: any;

    /** Se está carregando a revisão */
    isLoadingRevisao: boolean;
    /** Revisão que está sendo aprovada */
    revisao: ClienteAnaliseMercadoRevisaoSearch;
    /** Request para aprovar a revisão das Análises de Mercado */
    req: ClienteAnaliseMercadoRevisaoAprovarRequest;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private clienteAnaliseMercadoRevisaoHttpService: ClienteAnaliseMercadoRevisaoHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find(this.modal.nativeElement) as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', async (e: any) => {
                this.revisao = await this.searchRevisaoAtual();
                setTimeout(() => this.setFocusJustificativa(), 200);
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Pesquisa a revisão atual das Análises de Mercado no ano e representante informados */
    private searchRevisaoAtual(): Promise<ClienteAnaliseMercadoRevisaoSearch> {
        return new Promise<ClienteAnaliseMercadoRevisaoSearch>((resolve, reject) => {
            this.isLoadingRevisao = true;
            this.revisao = null;
            this.clienteAnaliseMercadoRevisaoHttpService.searchAtual(this.req.ano, this.req.idRepresentante)
                .pipe(take(1))
                .subscribe(
                    (revisao) => resolve(revisao),
                    (error: ApiError) => {
                        this.messageService.error(error.message, error.cause, error);
                        this.close();
                    },
                    () => setTimeout(() => this.isLoadingRevisao = false, 200)
                );
        });
    }

    /** Abre a modal para aprovar a revisão das Análises de Mercado */
    open(ano: number, idRepresentante: number) {
        this.req = new ClienteAnaliseMercadoRevisaoAprovarRequest(ano, idRepresentante, null);
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.clear();
        this.elModal.modal('hide');
    }


    /** Verifica os dados estão válidos para aprovar a revisão das Análises de Mercado */
    private isValid(): boolean {
        // Nenhum dado para parovar
        if (!this.req) {
            this.messageService.warning('Nenhum dado para aprovar a revisão das Análise de Mercado. Atualize a página e tente atualizar novamente. Se o problema persistir entre em contato com o suporte', 'Atenção');
            return false;
        }

        // Sem justificativa informada
       if (!this.req.justificativa || this.req.justificativa.trim().length < 15) {
            this.messageService.warning('A justificativa deve ter no mínimo 15 caracteres', 'Atenção');
            this.setFocusJustificativa();
            return false;
        }

        return true;
    }

    /** Aprova a revisão das Análises de Mercado */
    aprovar() {
        // Validando
        if (!this.isValid()) {
            return;
        }

        const btn = new ButtonLoader('#btnRevisaoAprovar');
        btn.loading('Aprovando');

        this.clienteAnaliseMercadoRevisaoHttpService.aprovar(this.req)
            .pipe(take(1))
            .subscribe(
                entity => {
                    this.messageService.success('', `Revisão #${this.revisao?.revisao} aprovada com sucesso`);
                    this.afterAprovar.emit(entity);
                    btn.reset();
                    this.close();
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, error.cause, error);
                    btn.reset();
                }
            );
    }

    /** Seta o foco no campo da justificativa */
    setFocusJustificativa() {
        jQuery(this.textAreaJustificativa.nativeElement).trigger('focus');
    }

    /** Limpa as variáveis do modal */
    private clear() {
        this.isLoadingRevisao = false;
        this.revisao = null;
        this.req = null;
    }
}
